import { TIMELINE_HEADER_MAJOR_TICK_SPACING } from "../../../../constants";
import { TimelineZoomLimits } from "../../../../constants/zoomRange";
import { calendarPrecalculations } from "./dateInternalCalculations";

const MIN_VS_MAX_RATIO = 2;

export const unitScaleForZoomLimit = (calendar, zoomLimit, isZoomFrom) => {
  // how many pixels should the unit be spread across?
  const pixelSpread = isZoomFrom
    ? TIMELINE_HEADER_MAJOR_TICK_SPACING / MIN_VS_MAX_RATIO
    : TIMELINE_HEADER_MAJOR_TICK_SPACING * MIN_VS_MAX_RATIO;
  const precalculations = calendarPrecalculations(calendar);
  switch (zoomLimit) {
    case TimelineZoomLimits.Billion:
      return (1000000000 * precalculations.avgSecondsInYear) / 20; // Special case - max units per pixel
    case TimelineZoomLimits.Million:
      return (1000000 * precalculations.avgSecondsInYear) / pixelSpread;
    case TimelineZoomLimits.Thousand:
      return (1000 * precalculations.avgSecondsInYear) / pixelSpread;
    case TimelineZoomLimits.Century:
      return (1000 * precalculations.avgSecondsInYear) / pixelSpread;
    case TimelineZoomLimits.Decade:
      return (10 * precalculations.avgSecondsInYear) / pixelSpread;
    case TimelineZoomLimits.Year:
      return precalculations.avgSecondsInYear / pixelSpread;
    case TimelineZoomLimits.Month:
      return precalculations.avgSecondsInMonth / pixelSpread;
    case TimelineZoomLimits.Week:
      return precalculations.secondsInWeek / pixelSpread;
    case TimelineZoomLimits.Day:
      return precalculations.secondsInDay / pixelSpread;
    case TimelineZoomLimits.Hour:
      return 3600 / pixelSpread;
    case TimelineZoomLimits.Minute:
      return 60 / pixelSpread;
    default:
      return 0.01; // special case - min units per pixel
  }
};

/**
 *
 * @param {CalendarRecord|Object} calendar
 * @return { key: value of zoom range, value: unit scale }
 */
const getZoomFromUnitScales = calendar => {
  return Object.keys(TimelineZoomLimits).reduce((arr, k) => {
    arr.push({ key: TimelineZoomLimits[k], value: unitScaleForZoomLimit(calendar, TimelineZoomLimits[k], true) });
    return arr;
  }, []);
};

/**
 *
 * @param {CalendarRecord|Object} calendar
 * @return { key: value of zoom range, value: unit scale }
 */
const getZoomToUnitScales = calendar => {
  return Object.keys(TimelineZoomLimits).reduce((arr, k) => {
    arr.push({ key: TimelineZoomLimits[k], value: unitScaleForZoomLimit(calendar, TimelineZoomLimits[k], false) });
    return arr;
  }, []);
};

export { getZoomFromUnitScales, getZoomToUnitScales };
